<template>
    <div v-if="reports.length" class="report-lift-block">
        <air-quality-report-list-item v-for="item in reports" :key="item.id" :model="item" />
        <a v-if="model.link" :href="model.link" class="button d-inline-flex my-4 align-items-center">
            {{ model.linkText }}
            <span class="arrow-icon d-inline-flex justify-content-center align-items-center ml-2" aria-hidden="true">
                <svg class="icon icon-hsy-icon-arrow-right-short-bold"><use xlink:href="#icon-hsy-icon-arrow-right-short-bold"></use></svg>
            </span>
        </a>
    </div>
</template>
<script>
    import axios from 'axios';
    import AirQualityReportListItem from './Listing/items/air-quality-report-list-item.vue';
    export default {
        components: {
            'air-quality-report-list-item': AirQualityReportListItem
        },
        props: {
            model: {
                type: Object,
                required: true,
                default: () => ({
                    tag: "",
                    pageSize: 0
                })
            }
        },
        data() {
            return {
                reports: [],
            }
        },
        mounted() {
            this.load();
        },
        methods: {
            load() {
                axios.get("/api/v1/airqualityreport/items", {
                        params: {
                            tag: this.model.tag,
                            pageSize: this.model.pageSize
                        }
                    })
                    .then((response) => {
                        this.reports = [...this.reports, ...response.data.hits];
                    }).catch((error) => {
                        console.error(error);
                    });
            }
        }
    }
</script>